export default __webpack_public_path__ + "media/images/tenant/hero_1-0fc7a77cb258735825ef97397c2a827e.jpg";